/**
 * @typedef {import('../../../../App/shared/SubscriptionService/CheckoutSession').default} CheckoutSession
 * @typedef {import('./Response').default} Response
 */

import { subscriptionService } from '../../../../service-container';
import { useEffect, useMemo, useState } from 'react';
import captureError from '../../../../utils/captureError';

/** @returns {Response} */
export default function useGetAgentCheckoutLinks() {
	const [checkoutLinks, setCheckoutLinks] = useState(
		/** @type {CheckoutSession | null} */ (null)
	);
	const [isGettingData, setIsGettingData] = useState(true);

	useEffect(() => {
		getCheckoutLinks();
	}, []);

	async function getCheckoutLinks() {
		try {
			const checkoutSessions =
				await subscriptionService.getAgentSubscriptionCheckoutLink();

			setCheckoutLinks(checkoutSessions);
		} catch (error) {
			captureError(error);
		} finally {
			setIsGettingData(false);
		}
	}

	return useMemo(
		() => ({
			data: checkoutLinks,
			isGettingData,
		}),
		[isGettingData, checkoutLinks]
	);
}
